module.exports = __webpack_public_path__ + "static/media/hinweis-krankenkassen-anerkannt-emr-zertifiziert.06af681b.svg";